import { render, staticRenderFns } from "./SavedRoutes.vue?vue&type=template&id=19f62ea8&scoped=true&"
import script from "./SavedRoutes.vue?vue&type=script&lang=js&"
export * from "./SavedRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f62ea8",
  null
  
)

export default component.exports